import React from 'react';
import { useNavigate } from 'react-router-dom';
import BackButton from '../components/BackButton';
import { useAppState } from '../state/AppState';
import { getProviderNameFromAvailability } from '../services/availabilityDataService';
import { createFindAnotherProviderHandler } from '../services/providerService';
import { isMobile } from '../utils/deviceUtils';
import { formatPhoneForTel } from '../utils/phoneUtils';

/**
 * ScreenU - Option not listed screen.
 *
 * Informs the user that their option is not listed and provides next steps.
 */
const ScreenU: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useAppState();
  const providerName = getProviderNameFromAvailability(state.availabilities, null);

  const handleCallNow = () => {
    if (isMobile()) {
      const phone = formatPhoneForTel();
      window.open(`tel:${phone}`);
    } else {
      navigate('/w');
    }
  };

  const handleProceedAnyway = () => {
    navigate('/i');
  };

  const handleFindAnotherProvider = createFindAnotherProviderHandler(state.stateString || undefined);

  return (
    <div className="screen-bg">
      <div className="main-content-container">
        <div className="mtg-back-btn-align">
          <BackButton onClick={() => navigate(-1)} />
        </div>
        <main className="mtg-screen-main">
          <div className="mtg-screen-card" style={{ textAlign: 'center', padding: 24 }}>
            <h2 className="mb-18" style={{ color: '#185F93', fontWeight: 700, fontSize: '1.25rem' }}>
              Check your insurance.
            </h2>
            <div className="mb-24" style={{ color: '#444', fontSize: '1.05rem' }}>
              Even though your insurance is not listed, {providerName} may still accept it. Please call us to check insurance.<br /><br />
              Or you may proceed and we will check your insurance and contact you if we find any issues.
            </div>
            <button className="pill-btn-standard mb-16" onClick={handleCallNow}>
              Call Now
            </button>
            <button className="pill-btn-standard mb-16" onClick={handleProceedAnyway}>
              I Will Self Pay
            </button>
            <button className="pill-btn-standard" onClick={handleFindAnotherProvider}>
              Find Another Provider
            </button>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ScreenU; 